<div class="modal-header">
  <h5 class="modal-title">Send Document</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>

<div class="modal-body">
  <app-automation-document-form
    [form]="form"
    [handlerFromTemplate]="true"
    [automation]="$safeNavigationMigration(data?.automation)"
  ></app-automation-document-form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <span class="far fa-times"></span>
    Cancel
  </button>

  <button (click)="onSave(form)" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-info">
    <span class="cs-icon cs-icon-save"></span>
    Save
  </button>
</div>
